import { useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import BackButton from "../../../components/buttons/BackButton"
import { BASE_URL } from "../../../utils/Constants"
import { ExpertRole } from "../../../utils/Enums"

const EmailRegistration = () => {
    const navigate = useNavigate()
    const location = useLocation()
    const defaultRole = location.pathname === "/email-registration-admin"
        ? ExpertRole.Admin
        : location.pathname === "/email-registration-physician"
            ? ExpertRole.Physician
            : ExpertRole.Nutritionist

    const [name, setName] = useState("")
    const [familyName, setFamilyName] = useState("")
    const [email, setEmail] = useState("")
    const [password, setPassword] = useState("")
    const [confirmPassword, setConfirmPassword] = useState("")
    const [role, setRole] = useState<ExpertRole>(defaultRole)

    const [isLoading, setIsLoading] = useState(false)

    const [newsletterAccepted, setNewsletterAccepted] = useState(false)

    const onConfirmButtonClicked = () => {
        callRegisterAPI()
    }

    const confirmButtonDisabled = name === "" || familyName === "" || email === "" || password === "" || confirmPassword === "" || password !== confirmPassword

    async function callRegisterAPI() {
        setIsLoading(true)
        const response = await fetch(`${BASE_URL}/auth/register`, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(
                {
                    email: email,
                    password: password,
                    name: name,
                    family_name: familyName,
                    privacy_policy: newsletterAccepted,
                    role: role,
                    mobile_phone: "+390000000000"
                })
        })
        setIsLoading(false)
        if (!response.ok) {
            const responseJson = await response.json()
            console.log(responseJson)
            if (response.status === 422) {
                alert("form error")
            } else {
                console.log()
            }
        } else {
            const responseJson = await response.json()
            console.log(responseJson)
            navigate(`/email-registration-code`, { state: { email, role, newsletterAccepted, name, familyName, password } })
        }
    }

    return (
        <div className="App">
            <div className={`h-[10%] w-full flex justify-center ${isLoading ? "opacity-30 pointer-events-none" : ""}`}>
                <div className="w-[90%] h-full flex items-center justify-between">
                    <BackButton
                        onClick={() => navigate("/login")}
                    />
                </div>
            </div>
            <div className={`h-[90%] w-full flex flex-col items-center justify-start overflow-y-auto ${isLoading ? "opacity-30 pointer-events-none" : ""}`}>
                <div className="w-[420px] h-[900px] flex flex-col justify-center items-center bg-white">
                    <div className="w-[392px] h-[800px] flex flex-col justify-between items-center">
                        <div className="font-bold text-[30px] leading-[24px]">
                            Crea il tuo account
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Ruolo
                            </label>
                            <div className="flex flex-col border-b border-black">
                                <select
                                    className="h-[40px] border-none bg-white focus:outline-none cursor-pointer"
                                    value={role}
                                    onChange={(e) => setRole(e.target.value as ExpertRole)}
                                >
                                    <option value={ExpertRole.Nutritionist}>Nutrizionista</option>
                                    <option value={ExpertRole.Physician}>Medico</option>
                                    <option value={ExpertRole.Admin}>Admin</option>
                                </select>
                            </div>
                        </div>
                        <div className="font-normal text-[14px] leading-[22px] text-center w-[328px]">
                            Creando un account, dichiari di aver letto e compreso le{" "}
                            <a
                                className="underline font-semibold cursor-pointer"
                                href={"/assets/personal-data-info.pdf"}
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Informazioni relative al trattamento dei dati personali
                            </a>.
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Nome
                            </label>
                            <div className="flex flex-col border-b border-black items-end">
                                <input
                                    className="leading-[5em] border-none w-[98%] h-[40px] focus:outline-none"
                                    type="text"
                                    placeholder="Nome"
                                    onChange={(e) => setName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Cognome
                            </label>
                            <div className="flex flex-col border-b border-black items-end">
                                <input
                                    className="leading-[5em] border-none w-[98%] h-[40px] focus:outline-none"
                                    type="text"
                                    placeholder="Cognome"
                                    onChange={(e) => setFamilyName(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Indirizzo e-mail
                            </label>
                            <div className="flex flex-col border-b border-black items-end">
                                <input
                                    className="leading-[5em] border-none w-[98%] h-[40px] focus:outline-none"
                                    type="text"
                                    placeholder="nome@esempio.com"
                                    onChange={(e) => setEmail(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="font-semibold text-[12px] leading-[22px] text-blue-500 w-[328px]">
                            Una password valida è composta da almeno 8 caratteri di cui: almeno una Maiuscola, una minuscola, un numero e un simbolo speciale (!$%& ...)
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Password
                            </label>
                            <div className="flex flex-col border-b border-black items-end">
                                <input
                                    className="leading-[5em] border-none w-[98%] h-[40px] focus:outline-none"
                                    type="password"
                                    placeholder="Password"
                                    onChange={(e) => setPassword(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="flex flex-col w-[328px]">
                            <label className="font-semibold text-[12px] uppercase">
                                Conferma Password
                            </label>
                            <div className="flex flex-col border-b border-black items-end">
                                <input
                                    className="leading-[5em] border-none w-[98%] h-[40px] focus:outline-none"
                                    type="password"
                                    placeholder="Conferma Password"
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                />
                            </div>
                        </div>
                        <div className="w-[328px] font-normal text-[14px] leading-[20px] flex">
                            <div
                                className="flex justify-center items-center w-[26px] h-[26px] rounded-[8px] border border-black mr-[10px] cursor-pointer"
                                onClick={() => { setNewsletterAccepted(!newsletterAccepted) }}
                            >
                                <div className={`w-[20px] h-[20px] rounded-[6px] bg-black ${newsletterAccepted ? "" : "invisible"}`} />
                            </div>
                            <div className="font-normal text-[14px] leading-[20px] w-[290px]">
                                Dichiaro di voler ricevere newsletter o comunicazioni commerciali da parte di Holifya.<br></br>
                                <a
                                    href={"/assets/newsletter.pdf"}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="underline font-semibold cursor-pointer"
                                >
                                    Informativa relativa alla newsletter
                                </a>
                            </div>
                        </div>
                        <button
                            className={`w-[328px] h-[55px] border-none rounded-[5px] text-white font-bold text-[14px] uppercase primary-action-color-background ${!confirmButtonDisabled ? "cursor-pointer" : ""}`}
                            disabled={confirmButtonDisabled}
                            onClick={onConfirmButtonClicked}
                        >
                            Continua
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EmailRegistration
